import React, { useEffect, useRef, useState } from "react";
// import { Link } from 'react-router-dom'
import {
  Autocomplete,
  TextField,
  Tabs,
  Tab,
  FormControl,
  RadioGroup,
  Modal,
  FormControlLabel,
  Radio,
  InputLabel,
  Select,
  Menu,
  MenuItem,
  Box,
  Typography,
  Tooltip,
  Zoom,
  TableContainer,
  TableCell,
  TableRow,
  Table,
  TableHead,
  Checkbox,
  TableBody,
  TablePagination,
  ToggleButtonGroup,
  ToggleButton,
  Button,
  List,
  ListItemButton,
} from "@mui/material";
import MainPage from "../_layout/main.page";
import ControlPointOutlinedIcon from "@mui/icons-material/ControlPointOutlined";
import { v4 as uuidv4 } from "uuid";
import MarkUnreadChatAltOutlinedIcon from "@mui/icons-material/MarkUnreadChatAltOutlined";
import nopdf from "../assets/images/nopdffile.png";
import { Link, useNavigate, useParams } from "react-router-dom";
import MessageSnackbar from "../_layout/elements/snackbar";
import host from "../host";
import pdffile from "../assets/images/pdf-file.svg";
import PageLoader from "../components/page-loader";
import { useDispatch } from "react-redux";
import { changeAuth } from "../actions/loginAction";
import user from "../assets/images/user.png";
import UploadType from "../components/upload-type";
import AddIcon from "@mui/icons-material/Add";
import ListIcon from "@mui/icons-material/List";
import GridViewOutlinedIcon from "@mui/icons-material/GridViewOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import CloseIcon from "@mui/icons-material/Close";
import FilterListOutlinedIcon from "@mui/icons-material/FilterListOutlined";
import TableLoader from "../components/loader/table-loader";
import SearchLoader from "../components/loader/search_loader";
import AddBrain from "../components/add-brain";
import emptyfolder from "../assets/images/empty-folder.png";
import LibraryReactPdf from "../components/pdf_view/library-react-pdf";
import PdfList from "../components/pdflist";
import PdfThumbnail from "../components/pdfthumbnail";
import HeaderPage from "../_layout/elements/header";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
export const BrainSetting = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  //brain - list functionality begins
  const [snackbar, setSnackbar] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const onClose = () => {
    setSnackbar(false);
  };

  const [alignment, setAlignment] = React.useState("grid");
  const handleAlignment = (event, newAlignment) => {
    setAlignment(newAlignment);
  };

  const [brainList, setBrainList] = useState([]);
  const [selectedBrain, setSelectedbrain] = useState(null);

  //add brain
  const [openaddbrain, setOpendeleteaddbrain] = React.useState(false);
  const activeaddbrain = () => setOpendeleteaddbrain(true);
  const handleCloseaddbrain = () => {
    setOpendeleteaddbrain(false);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getbrains = () => {
    //  setIsLoaded(false);
    fetch(host.chaturl + `/brain`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 403) {
          dispatch(changeAuth(false, null));
          navigate("/logout");
        } else {
          // setIsLoaded(true);
          setSeverity("error");
          setMessage("Something went wrong");
          setSnackbar(true);
        }
      })
      .then((data) => {
        if (data) {
          setBrainList(data);
          //  setIsLoaded(true);
        }
      })
      .catch((err) => {
        console.log(err);
        //   setIsLoaded(true);
      });
  };

  useEffect(() => {
    if (brainList.length > 0) {
      setSelectedbrain(brainList[0]);
    }
  }, [brainList]);

  useEffect(() => {
    getbrains();
  }, []);
  //brain - list functionality ends
  //upload document implementaion starts
  // const [searchByFile, setSearchByFile] = useState("");
  const [searchByBrain, setSearchByBrain] = useState(null);
  const [pdfListLoading, setPdfListLoading] = useState(false);
  const [pdfListData, setPdfListData] = useState([]);
  const [selectedPDFs, setSelectedPDFs] = useState([]);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [totalCount, setTotalCount] = useState();

  const handleChatAllDoc = () => {
    // const pdfIdListData = pdfListData.map((item) => item.id);
    //navigate(`/home?knowledge=[${pdfIdListData.join(",")}]`);
    getDocChatId([]);
  };

  const handleChatSelectedDoc = () => {
    const selectedIdPDFs = selectedPDFs.map((item) => item.id);
    getDocChatId(selectedIdPDFs);
    // navigate(`/home?knowledge=[${pdfIdListData.join(",")}]`);
  };

  const handleChatSpecificDoc = (pdf) => {
    getDocChatId([pdf.id]);
  };

  const getDocChatId = (docList) => {
    //Yet to be implemented if it came from handleChatAllDoc, array is empty and dont add it to the body. if handleChatSelectedDoc, send the array as parameter

    let payload = {
      chat_name: "random",
      knowledges: docList,
    };

    if (docList.length === 0) {
      payload = {
        chat_name: "random",
      };
    }

    fetch(host.chaturl + "/chat/knowledges", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      body: JSON.stringify(payload),
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 403) {
          dispatch(changeAuth(false, null));
          navigate("/logout");
        } else {
          setSeverity("error");
          setMessage("Something went wrong");
          setSnackbar(true);
        }
      })
      .then((data) => {
        if (data) {
          navigate(`/knowledgeChat/${data.chat_id}`);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getKnowledge = async (id) => {
    setPdfListLoading(true);
    let mainQuery = `${host.chaturl}/knowledge/${id}`;
    // if (searchByFile !== "") {
    //   mainQuery += `&file_name=${searchByFile}`;
    // }

    if (searchByBrain !== null) {
      mainQuery += `&brain_id=${searchByBrain.id}`;
    }
    await fetch(mainQuery, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 403) {
          dispatch(changeAuth(false, null));
          navigate("/logout");
        } else {
          setPdfListLoading(false);
          setSeverity("error");
          setMessage("Something went wrong");
          setSnackbar(true);
        }
      })
      .then((data) => {
        if (data) {
          setPdfListData(data);
          setTotalCount(data.total_count ? data.total_count : 0);
          setPdfListLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setPdfListLoading(false);
      });
  };
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      //setPage(1);
      Promise.all([getKnowledge(id)])
        .then(() => {})
        .catch((_error) => {});
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchByBrain, page, limit]);

  const [searchByContext, setSearchByContext] = useState("");
  const [searchContextResult, setSearchContextResult] = useState(null);
  const [filteredResults, setFilteredResults] = useState([]);
  const [searchContextLoading, setSearchContextLoading] = useState(false);
  const [statusFilter, setStatusFilter] = useState("all");
  const [dateFilter, setDateFilter] = useState("any_date");

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleStatusFilterChange = (event) => {
    setStatusFilter(event.target.value);
  };

  const handleDateFilterChange = (value) => {
    setDateFilter(value);
    handleClose();
  };

  const getSearchResult = () => {
    setSearchContextLoading(true);
    let mainQuery = `${host.chaturl}/knowledge/search?search_query=${searchByContext}`;
    fetch(mainQuery, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 403) {
          dispatch(changeAuth(false, null));
          navigate("/logout");
        } else {
          setSearchContextLoading(false);
          setSeverity("error");
          setMessage("Something went wrong");
          setSnackbar(true);
        }
      })
      .then((data) => {
        if (data.length > 0) {
          setSearchContextResult(data);
          setSearchContextLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setSearchContextLoading(false);
      });
  };

  useEffect(() => {
    if (searchByContext !== "") {
      const delayDebounceFn = setTimeout(() => {
        Promise.all([getSearchResult()])
          .then(() => {})
          .catch((_error) => {});
      }, 500);
      return () => clearTimeout(delayDebounceFn);
    }
  }, [searchByContext]);

  const isDateInRange = (dateString, dateFilter) => {
    const itemDate = new Date(dateString);
    const currentDate = new Date();
    console.log(itemDate);

    // Calculate the start date based on the date filter
    let startDate;
    switch (dateFilter) {
      case "last_24_hours":
        startDate = new Date(currentDate.getTime() - 24 * 60 * 60 * 1000);
        break;
      case "last_week":
        startDate = new Date(currentDate.getTime() - 7 * 24 * 60 * 60 * 1000);
        break;
      case "last_month":
        startDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, currentDate.getDate());
        break;
      case "last_year":
        startDate = new Date(currentDate.getFullYear() - 1, currentDate.getMonth(), currentDate.getDate());
        break;
      default:
        return true;
    }

    // Check if the item's date is within the selected range
    return itemDate >= startDate && itemDate <= currentDate;
  };

  const filterResults = () => {
    if (searchContextResult.length === 0) return;

    const filtered = searchContextResult.filter((item) => {
      if ((statusFilter !== "all" && item.status !== statusFilter) || (dateFilter !== "any_date" && !isDateInRange(item.created_at, dateFilter))) {
        return false;
      }
      return true;
    });
    setFilteredResults(filtered);
  };

  useEffect(() => {
    if (searchContextResult && searchContextResult.length > 0) {
      filterResults();
    }
  }, [statusFilter, dateFilter, searchContextResult]);

  //upload document implementaion ends

  //library pdf implementation starts
  const [activePdf, setActivePdf] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const toggleDrawer = (file_path, file_name, id) => {
    setActivePdf({ file_path, file_name, id });
    setIsOpen(true);
  };
  const closeDrawer = () => {
    setIsOpen(false);
  };
  const urlParams = new URLSearchParams(window.location.search);

  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
    // Create a URLSearchParams object with the current URL parameters
    const urlParameters = new URLSearchParams(window.location.search);
  
    // Set the 'tab' parameter to the new tab value
    urlParameters.set('tab', newValue);
  
    // Update the URL without reloading the page
    window.history.pushState({}, '', '?' + urlParameters.toString());
  };

  useEffect(() => {
    const urlParameters = new URLSearchParams(window.location.search);
    if (urlParameters.has('tab')) {
      setValue(Number(urlParameters.get('tab')));
    }
    else {
      setValue(0);
    }
  }, []);
  


  const [progress, setProgress] = React.useState(0);
  React.useEffect(() => {
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress === 100) {
          return 0;
        }
        const diff = Math.random() * 10;
        return Math.min(oldProgress + diff, 100);
      });
    }, 500);
    return () => {
      clearInterval(timer);
    };
  }, []);

  //this below function for delete member   popup start//
  const [opendelete, setOpendelete] = React.useState(false);
  const activedelet = () => setOpendelete(true);
  const handleClosedelete = () => {
    setOpendelete(false);
    setSelectedUsers("");
  };
  //this below function for delete member   popup end//

  //knowledge listing functionality begins

  const [knowledge, setKnowledge] = useState([]);
  const [fileLoaded, setFileLoaded] = useState(true);
  const [selectedLink, setSelectedLink] = useState("");

  const [openprompt, setOpendeleteprompt] = React.useState(false);
  const activeprompt = () => setOpendeleteprompt(true);
  const handleCloseprompt = () => setOpendeleteprompt(false);

  useEffect(() => {
    if (knowledge.length > 0) {
      setSelectedLink(knowledge[0].id);
    }
  }, [knowledge]);

  //knowledge listing functionality ends

  // upload knowledge functionality begins

  const [selectedFiles, setSelectedFiles] = useState([]);
  const [fileLoading, setFileLoading] = useState(false);
  const fileInputRef = useRef(null);
  const MAX_FILE_SIZE = 10 * 1024 * 1024; // size limit for file in future

  const handleFileChange = (event) => {
    const files = event.target.files;
    const newSelectedFiles = Array.from(files).filter((file) => file.size <= MAX_FILE_SIZE);
    // setSelectedFiles(newSelectedFiles);
    setSelectedFiles((prevSelectedFiles) => [...prevSelectedFiles, ...newSelectedFiles]);
  };

  const handleFileDrop = (e) => {
    e.preventDefault();
    const files = e.dataTransfer.files;
    const newSelectedFiles = Array.from(files).filter((file) => file.size <= MAX_FILE_SIZE);
    // setSelectedFiles(newSelectedFiles);
    setSelectedFiles((prevSelectedFiles) => [...prevSelectedFiles, ...newSelectedFiles]);
  };

  const handleDrag = (e) => {
    e.preventDefault();
  };

  const handleDeleteFile = (fileToDelete) => {
    setSelectedFiles(selectedFiles.filter((file) => file !== fileToDelete));
  };

  const handleUpload = () => {
    if (!selectedFiles[0]) {
      setSeverity("error");
      setMessage("Select a file please");
      setSnackbar(true);
      return;
    }
    setFileLoading(true);
    const formData = new FormData();
    formData.append("file", selectedFiles[0]);

    fetch(host.chaturl + `/brain/upload/${id}`, {
      method: "POST",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      body: formData,
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 403) {
          dispatch(changeAuth(false, null));
          navigate("/logout");
        } else {
          setFileLoading(false);
          setSeverity("error");
          setMessage("Something went wrong");
          setSnackbar(true);
        }
      })
      .then((data) => {
        setFileLoading(false);
        setSeverity("success");
        setMessage("Knowledge Uploaded Successfully");
        setSnackbar(true);
        setSelectedFiles([]);
        getKnowledge(id);
      })
      .catch((error) => {
        getKnowledge(id);
        console.error("Error uploading file:", error);
        setFileLoading(false);
      });
  };

  // upload knowledge functionality ends

  // brain settings functionality begins

  const [brainName, setBrainName] = useState("");
  const [brainDescription, setbrainDescription] = useState("");
  const [status, setStatus] = useState("");
  const [isLoaded, setIsLoaded] = useState(true);
  const [isPrompt, setIsPrompt] = useState(false);

  const getBrainDetails = () => {
    setIsLoaded(false);

    fetch(host.chaturl + `/brain/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 403) {
          dispatch(changeAuth(false, null));
          navigate("/logout");
        } else {
          setIsLoaded(true);
          setSeverity("error");
          setMessage("Something went wrong");
          setSnackbar(true);
        }
      })
      .then((data) => {
        setIsLoaded(true);
        setBrainName(data.name);
        setbrainDescription(data.description);
        setStatus(data.status);
        if (data.prompt_id !== "None") {
          setIsPrompt(true);
          getPromptDetails(data.prompt_id);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const editBrain = () => {
    if (brainName === "") {
      setSeverity("warning");
      setMessage("Please provide valid name ");
      setSnackbar(true);
      return;
    }

    setIsLoaded(false);

    fetch(host.chaturl + `/brain/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      body: JSON.stringify({
        name: brainName,
        description: brainDescription,
        status: status,
      }),
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 403) {
          dispatch(changeAuth(false, null));
          navigate("/logout");
        } else {
          setIsLoaded(true);
          setSeverity("error");
          setMessage("Something went wrong");
          setSnackbar(true);
        }
      })
      .then((data) => {
        setIsLoaded(true);
        setSeverity("success");
        setMessage("Brain Updated Successfully");
        setSnackbar(true);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  //prompt settings functionality begins

  const [promptLoaded, setPromptLoaded] = useState(true);
  const [promptName, setPromptName] = useState("");
  const [promptContent, setPromptContent] = useState("");
  const [promptList, setPromptList] = useState([]);
  const [selectedPrompt, setSelectedPrompt] = useState(null);
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const getPromptDetails = (prompt_id) => {
    setPromptLoaded(false);

    fetch(host.chaturl + `/prompt/${prompt_id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 403) {
          dispatch(changeAuth(false, null));
          navigate("/logout");
        } else {
          setPromptLoaded(true);
          setSeverity("error");
          setMessage("Something went wrong");
          setSnackbar(true);
        }
      })
      .then((data) => {
        if (data) {
          setPromptLoaded(true);
          setSelectedPrompt(data);
        }
      })
      .catch((err) => {
        console.log(err);
        setPromptLoaded(true);
      });
  };

  const getPrompts = () => {
    setPromptLoaded(false);

    fetch(host.chaturl + `/prompt`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 403) {
          dispatch(changeAuth(false, null));
          navigate("/logout");
        } else {
          setPromptLoaded(true);
          setSeverity("error");
          setMessage("Something went wrong");
          setSnackbar(true);
        }
      })
      .then((data) => {
        if (data) {
          setPromptLoaded(true);
          setPromptList(data);
        }
      })
      .catch((err) => {
        console.log(err);
        setPromptLoaded(true);
      });
  };

  const editPrompt = () => {
    let method;
    let selectedId;

    if (selectedPrompt === null) {
      setSeverity("warning");
      setMessage("Please select valid prompt");
      setSnackbar(true);
      return;
    }

    if (!isPrompt) {
      method = "POST";
      selectedId = id;
    } else {
      method = "PUT";
      selectedId = selectedPrompt.id;
    }

    setPromptLoaded(false);

    fetch(host.chaturl + `/prompt/${selectedId}`, {
      method: method,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      body: JSON.stringify({
        title: selectedPrompt.title,
        content: selectedPrompt.content,
      }),
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 403) {
          dispatch(changeAuth(false, null));
          navigate("/logout");
        } else {
          setPromptLoaded(true);
          setSeverity("error");
          setMessage("Something went wrong");
          setSnackbar(true);
        }
      })
      .then((data) => {
        setPromptLoaded(true);
        setSeverity("success");
        setMessage("Prompt Updated Successfully");
        setSnackbar(true);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const submitPrompts = () => {
    fetch(host.chaturl + `/prompt/${id}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      body: JSON.stringify({
        title: title,
        content: content,
      }),
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 403) {
          dispatch(changeAuth(false, null));
          navigate("/logout");
        } else {
          // setPromptLoaded(true);
          setSeverity("error");
          setMessage("Something went wrong");
          setSnackbar(true);
        }
      })
      .then((data) => {
        if (data) {
          // setPromptLoaded(true);
          if (data.prompt && data.prompt._id) {
            getPromptDetails(data.prompt._id);
          }
          setSeverity("success");
          setMessage(data.message);
          setSnackbar(true);
          handleCloseprompt();
          setTitle("");
          setContent("");
        }
      })
      .catch((err) => {
        console.log(err);
        setPromptLoaded(true);
      });
  };

  useEffect(() => {
    if (selectedPrompt) {
      setPromptName(selectedPrompt.title);
      setPromptContent(selectedPrompt.content);
    }
  }, [selectedPrompt]);

  //prompt settings functionality ends

  // users functionality begins

  //this below function for open action box table  start//
  const [isVisible, setIsVisible] = useState(false);
  const handleCheckboxChange = (event) => {
    setIsVisible(event.target.checked);
  };
  //this below function for open action box table  end//
  //this below function for table  pagination start//

  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  //this below function for table  pagination start//

  const [allUsers, setAllUsers] = useState([]);
  const [allUsersLoaded, setAllUsersLoaded] = useState(true);
  const [accessUsersLoaded, setAccessUsersLoaded] = useState(true);
  const [accessUsers, setAccessUsers] = useState([]);
  const [addedUsers, setAddedUsers] = useState([{ email: "", rights: "none", id: uuidv4() }]);
  const [selectedUsers, setSelectedUsers] = useState("");

  const handleAddUser = () => {
    setAddedUsers([...addedUsers, { email: "", rights: "none", id: uuidv4() }]);
  };

  const handleDeleteUser = (index) => {
    const newArray = [...addedUsers];
    newArray.splice(index, 1);
    setAddedUsers(newArray);
  };

  const getAllUsers = () => {
    setAllUsersLoaded(false);

    fetch(host.chaturl + "/user/list", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 403) {
          dispatch(changeAuth(false, null));
          navigate("/logout");
        } else {
          setAllUsersLoaded(true);
          setSeverity("error");
          setMessage("Something went wrong");
          setSnackbar(true);
        }
      })
      .then((data) => {
        const temp = data.map((item) => {
          return { label: item.email, id: item._id };
        });
        setAllUsers(temp);
        setAllUsersLoaded(true);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getUsersWithAccess = () => {
    setAccessUsersLoaded(false);

    fetch(host.chaturl + `/brain/${id}/access?page=${page + 1}&limit=${rowsPerPage}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 403) {
          dispatch(changeAuth(false, null));
          navigate("/logout");
        } else {
          setAccessUsersLoaded(true);
          setSeverity("error");
          setMessage("Something went wrong");
          setSnackbar(true);
        }
      })
      .then((data) => {
        setAccessUsers(data.users);
        setTotalCount(data.total_count);
        setAccessUsersLoaded(true);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const addUsers = () => {
    const toBeAdded = addedUsers.filter((user) => user.email !== "" && user.rights !== "none").map((user) => ({ email: user.email, rights: user.rights }));

    const hasEmptyEmail = addedUsers.some((user) => user.email.trim() === "");
    const hasNoneRights = addedUsers.some((user) => user.rights === "none");

    if (hasEmptyEmail || hasNoneRights) {
      setSeverity("warning");
      setMessage("Select All Relevant Properties");
      setSnackbar(true);
      return;
    }

    if (toBeAdded.length === 0) {
      setSeverity("warning");
      setMessage("Select All Relevant Properties");
      setSnackbar(true);
      return;
    }

    fetch(host.chaturl + `/brain/${id}/invite`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      body: JSON.stringify(toBeAdded),
    })
      .then(async (res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 403) {
          dispatch(changeAuth(false, null));
          navigate("/logout");
        } else {
          setAllUsersLoaded(true);
          setSeverity("error");
          setMessage("Something went wrong");
          setSnackbar(true);
        }
      })
      .then((data) => {
        if (data.message === "Invites successfully sent!") {
          getAllUsers();
          getUsersWithAccess();
          setAddedUsers([{ email: "", rights: "none", id: uuidv4() }]);
        }
      })
      .catch((error) => {
        console.error("Error uploading file:", error);
        setAllUsersLoaded(true);
      });
  };

  const handleUserChange = (value, index) => {
    setAddedUsers((prevUsers) => {
      const updatedUsers = [...prevUsers];
      if (value === null) {
        updatedUsers[index] = { email: "", rights: "none", id: uuidv4() };
      } else if (value.label && value.id) {
        updatedUsers[index] = {
          email: value.label,
          rights: updatedUsers[index].rights,
          id: value.id,
        };
      }
      return updatedUsers;
    });
  };

  const handlePermissionChange = (index, permission) => {
    if (permission) {
      addedUsers[index] = {
        email: addedUsers[index].email,
        rights: permission,
        id: addedUsers[index].id,
      };
    }
  };

  const handleDeleteAccess = (access_id) => {
    activedelet();
    setSelectedUsers(access_id);
  };

  const deleteUserAccess = () => {
    setAccessUsersLoaded(false);
    fetch(host.chaturl + `/brain/${id}/access/${selectedUsers}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then(async (res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 403) {
          dispatch(changeAuth(false, null));
          navigate("/logout");
        } else {
          setAccessUsersLoaded(true);
          setSeverity("error");
          setMessage("Something went wrong");
          setSnackbar(true);
          setSelectedUsers("");
        }
      })
      .then((data) => {
        if (data.success) {
          getUsersWithAccess();
          setSeverity("success");
          setMessage("User Deleted Successfully");
          setSnackbar(true);
          setSelectedUsers("");
        }
      })
      .catch((error) => {
        console.error("Error uploading file:", error);
        setAccessUsersLoaded(true);
        setSelectedUsers("");
      });
  };

  const handleDeleteBrain = () => {
    setAccessUsersLoaded(false);
    fetch(host.chaturl + `/brain/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 403) {
          dispatch(changeAuth(false, null));
          navigate("/logout");
        } else {
          setAccessUsersLoaded(true);
          setSeverity("error");
          setMessage("Something went wrong");
          setSnackbar(true);
        }
      })
      .then((data) => {
        if (data.success) {
          setSeverity("success");
          setMessage("Brain Deleted Successfully");
          setSnackbar(true);
          navigate("/home");
        }
      })
      .catch((error) => {
        console.error("Error uploading file:", error);
        setAccessUsersLoaded(true);
      });
  };

  const getSignedPdf = (knowledgeId) => {
    // setPageLoaded(false);
    fetch(host.chaturl + `/knowledge/file/${knowledgeId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 403) {
          dispatch(changeAuth(false, null));
          navigate("/logout");
        } else {
          // setPageLoaded(true);
          setSeverity("error");
          setMessage("Something went wrong");
          setSnackbar(true);
        }
      })
      .then((data) => {
        // setActivePdf(data);
      })
      .catch((err) => {
        console.log(err);
        // setPageLoaded(true);
      });
  };
  const [isOwner, setIsOwner] = useState(false);
  const [isViewer, setIsViewer] = useState(false);
  const [isEditor, setIsEditor] = useState(false);
  useEffect(() => {
    if (id) {
      getKnowledge(id);
      getBrainDetails();
      getPrompts();
      getAllUsers();
    }
  }, [id]);

  useEffect(() => {
    if (isOwner === true) {
      getUsersWithAccess();
    }
  }, [isOwner]);

  useEffect(() => {
    const brain = brainList.find((brain) => brain.id === id);
    setIsOwner(brain && brain.rights === "Owner");
    setIsViewer(brain && brain.rights === "Viewer");
    setIsEditor(brain && brain.rights === "Editor");
  }, [brainList, id]);

  useEffect(() => {
    if (isOwner) {
      getUsersWithAccess();
    }
  }, [page, rowsPerPage, totalCount]);

  // users functionality ends

  // brain settings functionality ends

  useEffect(() => {
    if (!localStorage.getItem("login")) {
      navigate("/logout");
    }
  }, [localStorage.getItem("login")]);

  return (
    <>
      <MainPage>
        <HeaderPage />
        <MessageSnackbar open={snackbar} autoHideDuration={3000} onClose={onClose} severity={severity} message={message} />
        <div className="page_head-top  ">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="page_head_top_flex">
                  <div className="page-head-title ">
                    <div className="title-image">
                      <FolderOutlinedIcon />
                      {/* <img src={brain} alt="" height={25} /> */}
                      <h5>{brainName}</h5>
                    </div>
                  </div>
                  {/* <div className="page-head-buttons ">
            <button
              type="button"
              className="btn btn-danger"
              onClick={deleteUser}
            >
              Remove Access
            </button>
          </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="page-content">
          <section className="braintabs bg-white">

      
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <Tabs value={value} onChange={handleChange} variant="scrollable" scrollButtons="auto" aria-label="scrollable auto tabs example">
                  <Tab label="Settings" />
                  {isOwner && <Tab label="People" />}
                  {/* <Tab label="Library" /> */}
                </Tabs>
              </div>
            </div>
          </div>
          </section>

          <section className="section-pedding">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="tab-content">
                    <TabPanel value={value} index={0}>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="card">
                            <div className="card-body">
                              {isLoaded && promptLoaded && (
                                <div className="row">
                                  <div className="col-12">
                                    <div className="form-group">
                                      <label>
                                        Folder Name <span className="text-danger">*</span>
                                      </label>
                                      <TextField
                                        id="outlined-basic"
                                        type="text"
                                        placeholder="Enter folder name"
                                        size="small"
                                        value={brainName}
                                        onChange={(e) => {
                                          setBrainName(e.target.value);
                                        }}
                                        disabled={isViewer}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-12">
                                    <div className="form-group">
                                      <label>Folder Description </label>
                                      <TextField
                                        id="outlined-basic"
                                        type="text"
                                        placeholder="Enter description of the folder"
                                        multiline
                                        rows={4}
                                        value={brainDescription}
                                        onChange={(e) => {
                                          setbrainDescription(e.target.value);
                                        }}
                                        disabled={isViewer}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-12">
                                    <div className="form-group">
                                      <label> Folder Access</label>
                                      <FormControl>
                                        <RadioGroup aria-label="options" name="options" row>
                                          <div className="radio-text">
                                            <FormControlLabel
                                              value="option1"
                                              control={
                                                <Radio
                                                  checked={status === "public"}
                                                  onClick={() => {
                                                    setStatus("public");
                                                  }}
                                                  disabled={isViewer}
                                                />
                                              }
                                              label="Public"
                                            />
                                            <span className="shortcontent">This folder will be shared throughout the chatbot community</span>
                                          </div>
                                          <div className="radio-text">
                                            <FormControlLabel
                                              value="option2"
                                              control={
                                                <Radio
                                                  checked={status === "private"}
                                                  onClick={() => {
                                                    setStatus("private");
                                                  }}
                                                  disabled={isViewer}
                                                />
                                              }
                                              label="Private"
                                            />
                                            <span className="shortcontent">Accessible to you and those with whom you choose to share it</span>
                                          </div>
                                        </RadioGroup>
                                      </FormControl>
                                    </div>
                                  </div>
                                  {/* <div className="col-12">
                                    <div className="form-group">
                                      <label> Library source</label>
                                      <FormControl>
                                        <RadioGroup row aria-labelledby="demo-row-radio-buttons-group-label" name="row-radio-buttons-group">
                                          <FormControlLabel value="Documents" control={<Radio checked={true} />} label="Documents" />
                                        </RadioGroup>
                                      </FormControl>
                                    </div>
                                  </div> */}
                                  {!isViewer && (
                                    <div className="col-12 mt-3">
                                      <div className="form-group text-center">
                                        <button type="button" className="btn btn-primary w-50" onClick={editBrain}>
                                          Save
                                        </button>
                                      </div>
                                    </div>
                                  )}
                                  {/* <div className="brain-form-title mb-4">
                                    <div className="d-flex align-items-center mt-3  ">
                                      <hr className="flex-grow-1 bg-dark-4" />
                                      <span className="mx-2 text-2 text-muted">
                                        {" "}
                                        <span className="text-bold600">Custom prompt</span>
                                      </span>
                                      <hr className="flex-grow-1 bg-dark-4" />
                                    </div>
                                  </div>
                                  <div className="col-12">
                                    <div className="form-group">
                                      <FormControl fullWidth size="small">
                                        <InputLabel id="demo-select-small-label">Select a ChatBot Personality</InputLabel>
                                        <Select labelId="demo-select-small-label" id="demo-select-small" label="Age" value={selectedPrompt ? selectedPrompt.id : null}>
                                          {promptList &&
                                            promptList.length > 0 &&
                                            promptList.map((prompt, index) => {
                                              return (
                                                <MenuItem
                                                  value={prompt.id}
                                                  key={index}
                                                  onClick={() => {
                                                    setSelectedPrompt(prompt);
                                                  }}
                                                >
                                                  <em>{prompt.title ? prompt.title : "NA"}</em>
                                                </MenuItem>
                                              );
                                            })}
                                        </Select>
                                      </FormControl>
                                    </div>
                                  </div>
                                  <div className="col-12">
                                    <div className="form-group">
                                      <label> Prompt title</label>
                                      <FormControl fullWidth size="small">
                                        <TextField
                                          id="outlined-basic"
                                          type="text"
                                          placeholder="My awesome prompt name"
                                          size="small"
                                          value={promptName}
                                          // onChange={(e) => {setPromptName(e.target.value);}}
                                        />
                                      </FormControl>
                                    </div>
                                  </div>
                                  <div className="col-12">
                                    <div className="form-group">
                                      <label>Prompt content</label>
                                      <FormControl fullWidth size="small">
                                        <TextField
                                          id="outlined-basic"
                                          type="text"
                                          placeholder="As an AI, your..."
                                          multiline
                                          value={promptContent}
                                          // onChange={(e) => {setPromptContent(e.target.value);}}
                                          rows={4}
                                        />
                                      </FormControl>
                                    </div>
                                  </div>

                                  <div className="col-12 mt-3">
                                    <div className="form-group text-center d-flex align-items-center justify-content-between">
                                      <button type="button" className="btn btn-primary w-50" onClick={editPrompt}>
                                        Submit Prompt
                                      </button>
                                      <Tooltip className="blue-tooltip" title="Add Prompt" TransitionComponent={Zoom} placement="top" arrow>
                                        <IconButton color="primary" aria-label="add an alarm" size="large" onClick={activeprompt}>
                                          <ControlPointIcon fontSize="inherit" />
                                        </IconButton>
                                      </Tooltip>
                                    </div>
                                  </div> */}
                                </div>
                              )}
                              {/* {!(isLoaded && promptLoaded) && <PageLoader />} */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </TabPanel>

                    <TabPanel value={value} index={isOwner ? 1 : -1}>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="card">
                            <div className="card-body">
                              <div className="row">
                                {allUsersLoaded && (
                                  <>
                                    {/* <div className="col-12">
                                      <div className="form-group">
                                        <label>Copy link </label>
                                        <div className="copylink">
                                          <TextField
                                            id="outlined-basic"
                                            type="text"
                                            placeholder="Click to copy link"
                                            size="small"
                                          />
                                          <div className="copyicon">
                                            <Link to="">
                                              <ContentCopyOutlinedIcon fontSize="small" />
                                              Copy
                                            </Link>
                                          </div>
                                        </div>
                                      </div>
                                    </div> */}
                                    <div className="col-12">
                                      <div className="form-group">
                                        <label>Add new users </label>
                                        <div className="Add_User_box">
                                          {addedUsers.map((user, index) => (
                                            <div className="adduser_row" key={user.id}>
                                              <FormControl fullWidth>
                                                <Autocomplete
                                                  size="small"
                                                  disablePortal
                                                  id="combo-box-demo"
                                                  options={allUsers}
                                                  value={user.email}
                                                  onChange={(event, values) => {
                                                    handleUserChange(values, index);
                                                  }}
                                                  renderInput={(params) => <TextField {...params} placeholder="Select User" />}
                                                />
                                              </FormControl>

                                              <span className="access-role">
                                                <FormControl fullWidth size="small">
                                                  <InputLabel id="demo-simple-select-label">Access permissions</InputLabel>
                                                  <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    label="Age"
                                                    onChange={(e) => {
                                                      handlePermissionChange(index, e.target.value);
                                                    }}
                                                  >
                                                    <MenuItem selected={addedUsers[index].rights === "Editor"} value={"Editor"}>
                                                      Edit
                                                    </MenuItem>
                                                    <MenuItem selected={addedUsers[index].rights === "Viewer"} value={"Viewer"}>
                                                      View
                                                    </MenuItem>
                                                  </Select>
                                                </FormControl>
                                              </span>

                                              <div className="resume-action">
                                                <Tooltip className="blue-tooltip" title="Delete Mail" TransitionComponent={Zoom} placement="top" arrow>
                                                  <Link to="#" onClick={() => handleDeleteUser(index)}>
                                                    <i className="las la-trash-alt"></i>
                                                  </Link>
                                                </Tooltip>
                                              </div>
                                            </div>
                                          ))}
                                          <div className="Add-User">
                                            <button type="button" className="btn btn-default" onClick={handleAddUser}>
                                              <ControlPointOutlinedIcon fontSize="small" />
                                              Add User
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-12 mt-3">
                                      <div className="form-group text-center">
                                        <button type="button" className="btn btn-primary w-50" onClick={addUsers}>
                                          Submit
                                        </button>
                                      </div>
                                    </div>
                                  </>
                                )}
                                {!allUsersLoaded && <PageLoader />}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6  ">
                          <div className="card h-100">
                            <div className="card-body">
                              <div className="user_table_title">
                                <h3>Users with access</h3>
                                <p>User list and access permissions</p>
                              </div>
                              {accessUsers.length === 0 && (
                                <div className="no_content-wrapper " style={{ display: "block" }}>
                                  <div className="no-content-box">
                                    <div className="no_content-icon">
                                      <img src={user} alt="" height={100} />
                                    </div>
                                    <div className="no_content-title">No user in list.</div>
                                    <div className="no_content-pera">{/* <span> To add knowledge to a brain, go to chat page then click on plus button on the left of the chat input  </span> */}</div>
                                  </div>
                                </div>
                              )}
                              <div className="user_list  " style={{ display: "block" }}>
                                <div className="col-md-12">
                                  <div className="web-table ">
                                    {isVisible && (
                                      <div className="candidate-table-action">
                                        <div className="candidate-table-action-row">
                                          <button type="button" className="btn btn-danger" onClick={activedelet}>
                                            Delete
                                          </button>
                                        </div>
                                      </div>
                                    )}

                                    {accessUsersLoaded && accessUsers && accessUsers.length > 0 && (
                                      <TableContainer className=" ">
                                        <Table aria-label="simple table">
                                          <TableHead>
                                            <TableRow>
                                              <TableCell padding="checkbox">
                                                <Checkbox
                                                  color="primary"
                                                  size="small"
                                                  checked={isVisible}
                                                  onChange={handleCheckboxChange}
                                                  inputProps={{
                                                    "aria-label": "select all desserts",
                                                  }}
                                                />
                                              </TableCell>

                                              <TableCell> User Email </TableCell>

                                              <TableCell> Access / permissions </TableCell>
                                              <TableCell> Action </TableCell>
                                            </TableRow>
                                          </TableHead>
                                          <TableBody>
                                            {accessUsers.map((user) => {
                                              return (
                                                <TableRow
                                                  sx={{
                                                    "&:last-child td, &:last-child th": { border: 0 },
                                                  }}
                                                >
                                                  <TableCell padding="checkbox">
                                                    <Checkbox
                                                      size="small"
                                                      color="primary"
                                                      inputProps={{
                                                        "aria-label": "select all desserts",
                                                      }}
                                                    />
                                                  </TableCell>

                                                  <TableCell> {user.email ? user.email : "NA"} </TableCell>
                                                  <TableCell>
                                                    {" "}
                                                    <span className="badge bg-inverse-success w-50 "> {user.rights ? user.rights : "NA"}</span>
                                                  </TableCell>

                                                  <TableCell>
                                                    <div className="resume-action  justify-content-center ">
                                                      <Tooltip className="blue-tooltip" title="Delete User" TransitionComponent={Zoom} placement="top" arrow>
                                                        <Link
                                                          onClick={() => {
                                                            handleDeleteAccess(user.id);
                                                          }}
                                                        >
                                                          <i className="las la-trash-alt"></i>{" "}
                                                        </Link>
                                                      </Tooltip>
                                                    </div>
                                                  </TableCell>
                                                </TableRow>
                                              );
                                            })}
                                          </TableBody>
                                        </Table>
                                      </TableContainer>
                                    )}
                                    {!accessUsersLoaded && <PageLoader />}

                                    {accessUsersLoaded && accessUsers && accessUsers.length > 0 && (
                                      <div className="table-pagination">
                                        <TablePagination
                                          rowsPerPageOptions={[5, 10, 25, 100]}
                                          component="div"
                                          rowsPerPage={rowsPerPage}
                                          page={page}
                                          count={totalCount}
                                          onPageChange={handleChangePage}
                                          onRowsPerPageChange={handleChangeRowsPerPage}
                                        />
                                      </div>
                                    )}
                                  </div>

                                  {/* <DataTableLoader/> */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </TabPanel>

                    <TabPanel value={value} index={isOwner ? 2 : 1}>
                      <div className="row justify-content-center">
                        <div className="library_wrapper">
                          <div className="library_flex_box">
                            <div className="library_Left_section">
                              <div className="library_top_head">
                                <div className="card_head_title">
                                  <div className="uploadtype">
                                    {brainList.length > 0 ? (
                                      <UploadType
                                        brainList={brainList}
                                        getKnowledge={() => {
                                          getKnowledge(id);
                                        }}
                                        getbrains={getbrains}
                                      />
                                    ) : (
                                      <button type="button" className="btn btn-default" onClick={activeaddbrain}>
                                        <AddIcon fontSize="small" />
                                        Add Brain
                                      </button>
                                    )}
                                  </div>
                                </div>
                                {searchByContext === "" && (
                                  <div className="card_action">
                                    <div className="change_list_view">
                                      <ToggleButtonGroup size="small" value={alignment} exclusive onChange={handleAlignment} aria-label="text alignment">
                                        <ToggleButton value="list" aria-label="left aligned">
                                          <ListIcon fontSize="small" />
                                        </ToggleButton>
                                        <ToggleButton value="grid" aria-label="centered">
                                          <GridViewOutlinedIcon fontSize="small" />
                                        </ToggleButton>
                                      </ToggleButtonGroup>
                                    </div>
                                  </div>
                                )}
                              </div>
                              <div className="library-sections">
                                <div className=" upload-pdflist">
                                  <div className="candidate-table-action">
                                    <div className="candidate-table-action-row">
                                      <div className="table_action_cta search_library_inputbox">
                                        <TextField
                                          id="outlined-multiline-flexible"
                                          placeholder="Search by content"
                                          value={searchByContext}
                                          onChange={(e) => {
                                            setSearchByContext(e.target.value);
                                          }}
                                        />
                                        <div className="search-icon">
                                          {searchByContext !== "" ? (
                                            <Link to="" onClick={() => setSearchByContext("")}>
                                              <Tooltip className="blue-tooltip" title="Clear search" TransitionComponent={Zoom} placement="top" arrow>
                                                <CloseIcon
                                                  style={{
                                                    fontSize: "22px",
                                                    color: "#919EAB",
                                                  }}
                                                />
                                              </Tooltip>
                                            </Link>
                                          ) : (
                                            <SearchOutlinedIcon />
                                          )}
                                        </div>
                                        {/* <FormControl fullWidth size="small">
                                <TextField
                                  size="small"
                                  id="outlined-multiline-flexible"
                                  label="Search Files"
                                  value={searchByFile}
                                  onChange={(e) => {
                                    setSearchByFile(e.target.value);
                                  }}
                                />
                              </FormControl> */}
                                      </div>
                                      {/* {brainList && brainList.length > 0 && (
                              <div className="table_action_cta">
                                <FormControl fullWidth size="small">
                                  <InputLabel id="demo-simple-select-label">
                                    Search by brain name
                                  </InputLabel>
                                  <Select
                                    key={
                                      searchByBrain
                                        ? searchByBrain.id
                                        : brainList[0].id
                                    }
                                    labelId="demo-select-small-label"
                                    id="demo-select-small"
                                    value={
                                      searchByBrain
                                        ? searchByBrain.id
                                        : brainList[0].id
                                    }
                                  >
                                    <MenuItem value={0}>Select Brain</MenuItem>
                                    {brainList.map((brain) => {
                                      return (
                                        <MenuItem
                                          value={brain.id}
                                          onClick={() => {
                                            setSearchByBrain(brain);
                                          }}
                                        >
                                          {brain.name ? brain.name : "NA"}
                                        </MenuItem>
                                      );
                                    })}
                                  </Select>
                                </FormControl>
                              </div>
                            )} */}

                                      <div className="table_action_cta">
                                        <div className="table_action_btn">
                                          <button type="button" className="btn btn-primary " onClick={handleChatAllDoc} disabled={brainList.length > 0 ? false : true}>
                                            <MarkUnreadChatAltOutlinedIcon fontSize="small" /> Chat With All Files
                                          </button>
                                          <button type="button" className="btn btn-default " onClick={handleChatSelectedDoc} disabled={selectedPDFs.length > 0 ? false : true}>
                                            <MarkUnreadChatAltOutlinedIcon fontSize="small" /> Chat with selected Files
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {searchByContext !== "" ? (
                                    <div className="library_search_section" id="librarysearch">
                                      <div className="library_search_wrapper ">
                                        <div className="library_search_head  ">
                                          <div className="sources_title">
                                            <h5>Search Results</h5>
                                          </div>
                                          <div className="search_filter">
                                            <div className="search_filter_row">
                                              <div className="search_filter_cta action_half">
                                                <FormControl fullWidth size="small">
                                                  <InputLabel id="demo-simple-select-label">Upload Status</InputLabel>
                                                  <Select labelId="demo-select-small-label" id="demo-select-small" value={statusFilter} onChange={handleStatusFilterChange}>
                                                    <MenuItem value="all">All</MenuItem>
                                                    <MenuItem value="completed">Processed</MenuItem>
                                                    <MenuItem value="processing">In Progress</MenuItem>
                                                  </Select>
                                                </FormControl>
                                              </div>
                                              {/* <div className="search_filter_cta action_half">
                                  <Autocomplete
                                    disablePortal
                                    id="combo-box-demo"
                                    options={people}
                                    size="small"
                                    renderInput={(params) => (
                                      <TextField {...params} label="People" />
                                    )}
                                  />
                                </div> */}
                                              <div className="search_filter_cta ">
                                                <Tooltip title="Sort by">
                                                  <Button onClick={handleClick} variant="outlined" startIcon={<FilterListOutlinedIcon />}>
                                                    Sort By
                                                  </Button>
                                                </Tooltip>
                                                <Menu anchorEl={anchorEl} id="account-menu" open={open} onClose={handleClose}>
                                                  <MenuItem selected={dateFilter === "any_date"} onClick={() => handleDateFilterChange("any_date")}>
                                                    Any Date
                                                  </MenuItem>
                                                  <MenuItem selected={dateFilter === "last_24_hours"} onClick={() => handleDateFilterChange("last_24_hours")}>
                                                    Last 24 hours
                                                  </MenuItem>
                                                  <MenuItem selected={dateFilter === "last_week"} onClick={() => handleDateFilterChange("last_week")}>
                                                    Last week
                                                  </MenuItem>
                                                  <MenuItem selected={dateFilter === "last_month"} onClick={() => handleDateFilterChange("last_month")}>
                                                    Last month
                                                  </MenuItem>
                                                  <MenuItem selected={dateFilter === "last_year"} onClick={() => handleDateFilterChange("last_year")}>
                                                    Last year
                                                  </MenuItem>
                                                </Menu>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        {searchContextLoading ? (
                                          <div className="skeleton_loader">
                                            <SearchLoader />
                                          </div>
                                        ) : filteredResults && filteredResults.length > 0 ? (
                                          <div className="library_search_body">
                                            <List className="">
                                              {filteredResults.map((item, index) => (
                                                <ListItemButton key={index} alignItems="center" className="mb-3" onClick={() => toggleDrawer(item.file_path, item.file_name)}>
                                                  <div className="pdficonlibrary">
                                                    <img src={pdffile} alt="" />
                                                  </div>
                                                  <div className="pdf_search_content">
                                                    <h5>{item.file_name}</h5>
                                                    {item.chunk !== "" ? (
                                                      <Typography
                                                        dangerouslySetInnerHTML={{
                                                          __html: item.chunk.replace(/<b>/g, "<mark>").replace(/<\/b>/g, "</mark>"),
                                                        }}
                                                      />
                                                    ) : (
                                                      ""
                                                    )}
                                                    <div className="search_file_detail">
                                                      <div className="search_file_row">
                                                        <span>Uploaded By </span>
                                                        <span>-</span>
                                                        <span>{item.user ? item.user.fullname : "NA"}</span>
                                                      </div>
                                                      <div className="search_devider">/</div>
                                                      <div className="search_file_row">
                                                        <span>
                                                          {new Date(item.created_at).toLocaleDateString("en-US", {
                                                            year: "numeric",
                                                            month: "short",
                                                            day: "numeric",
                                                          })}
                                                        </span>
                                                      </div>
                                                      <div className="search_devider">/</div>
                                                      <div className="search_file_row">
                                                        <span className={`d-flex gap-2 align-items-center`}>
                                                          <span className={`circle ${item.status === "completed" ? "bg-success" : "bg-warning"}`}></span>
                                                          {item.status === "completed" ? "Processed" : "Processing"}
                                                        </span>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </ListItemButton>
                                              ))}
                                            </List>
                                          </div>
                                        ) : (
                                          <div className="no_content-wrapper ">
                                            <div className="no-content-box">
                                              <div className="no_content-icon">
                                                <img src={emptyfolder} alt="" height={100} />
                                              </div>
                                              <div className="no_content-title">No results found</div>
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  ) : (
                                    <>
                                      {pdfListLoading ? (
                                        <div className="skeleton_loader">
                                          <TableLoader />
                                        </div>
                                      ) : (
                                        <>
                                          {pdfListData && pdfListData.length > 0 ? (
                                            <>
                                              {alignment === "list" && (
                                                <div className="pdf_table_wrapper">
                                                  <PdfList
                                                    page={page}
                                                    setPage={setPage}
                                                    limit={limit}
                                                    setLimit={setLimit}
                                                    totalCount={totalCount}
                                                    setTotalCount={setTotalCount}
                                                    selectedPDFs={selectedPDFs}
                                                    setSelectedPDFs={setSelectedPDFs}
                                                    pdfListData={pdfListData}
                                                    setPdfListData={setPdfListData}
                                                    handleChatSpecificDoc={handleChatSpecificDoc}
                                                    getKnowledge={() => {
                                                      getKnowledge(id);
                                                    }}
                                                  />
                                                </div>
                                              )}
                                              {alignment === "grid" && (
                                                <div className="pdf_thumbnail_wrapper">
                                                  <div className="pdf_thumbnail_row">
                                                    <div className="library_search_head  ">
                                                      <div className="sources_title">
                                                        <h5>Files</h5>
                                                      </div>
                                                    </div>
                                                    <div className="pdf_thumbnail_flex">
                                                      <PdfThumbnail
                                                        page={page}
                                                        setPage={setPage}
                                                        limit={limit}
                                                        setLimit={setLimit}
                                                        totalCount={totalCount}
                                                        setTotalCount={setTotalCount}
                                                        selectedPDFs={selectedPDFs}
                                                        setSelectedPDFs={setSelectedPDFs}
                                                        pdfListData={pdfListData}
                                                        setPdfListData={setPdfListData}
                                                        handleChatSpecificDoc={handleChatSpecificDoc}
                                                        getKnowledge={() => {
                                                          getKnowledge(id);
                                                        }}
                                                        toggleDrawer={toggleDrawer}
                                                      />
                                                    </div>
                                                    <div className="mt-4 table-pagination">
                                                      <TablePagination
                                                        rowsPerPageOptions={[5, 10, 25, 100]}
                                                        component="div"
                                                        rowsPerPage={limit}
                                                        page={page}
                                                        onPageChange={handleChangePage}
                                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                                        count={totalCount}
                                                      />
                                                    </div>
                                                  </div>
                                                </div>
                                              )}
                                            </>
                                          ) : (
                                            <div className="no_content-wrapper">
                                              <div className="no-content-box">
                                                <div className="no_content-icon">
                                                  <img src={nopdf} alt="" height={100} />
                                                </div>
                                                <div className="no_content-title">Empty mind, no documents uploaded </div>
                                                <div className="no_content-pera">
                                                  <span> Ignite your knowledge, tap 'Add Brain' button in the top left and breakthrough </span>
                                                </div>
                                              </div>
                                            </div>
                                          )}
                                        </>
                                      )}
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                            <AddBrain openaddbrain={openaddbrain} handleCloseaddbrain={handleCloseaddbrain} getbrains={getbrains} />
                            <div className={`library_open_pdf ${isOpen ? "open" : ""}`}>
                              {activePdf?.file_path && activePdf?.file_name && (
                                <LibraryReactPdf file_path={activePdf.file_path} file_name={activePdf.file_name} activePdf={activePdf} getSignedPdf={getSignedPdf} closeDrawer={closeDrawer} />
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <div className="row">
                        <div className="col-md-6">
                          <div className="card">
                            <div className="card-body">
                              <div className="row">
                                <div className="col-md-12">
                                  <div className="whatpdf_wrapper">
                                    <div className="whatpdf_title">
                                      <h3>Explore uploaded data</h3>
                                      <p>
                                        View, download or delete knowledge used
                                        by your brain
                                      </p>
                                    </div>
                                    {selectedFiles.length === 0 && (
                                      <>
                                        <div
                                          className="csv-upload "
                                          onDrop={handleFileDrop}
                                          onDragOver={handleDrag}
                                          onDragEnter={handleDrag}
                                          onDragLeave={handleDrag}
                                        >
                                          <div className="upload-pdf">
                                            <label htmlFor="file-upload1">
                                              <input
                                                type="file"
                                                id="file-upload1"
                                                style={{ visibility: "hidden" }}
                                                onChange={handleFileChange}
                                                ref={fileInputRef}
                                              />
                                              <div className="svg-circle">
                                                <FileUploadOutlinedIcon />
                                              </div>
                                              <h5>
                                                {" "}
                                                Drag and drop PDF files to
                                                upload{" "}
                                              </h5>
                                              <p>
                                                Your PDF will be private until
                                                you publish them.{" "}
                                              </p>
                                            </label>
                                          </div>
                                        </div>
                                      </>
                                    )}
                                    {selectedFiles.length > 0 && (
                                      <div className="uploaded-item-body">
                                        <div className="uploaded-item-scroll">
                                          {selectedFiles.map((file, index) => (
                                            <div
                                              className="uploaded-item-row"
                                              key={index}
                                            >
                                              <div className="file-row">
                                                <img
                                                  src={pdffile}
                                                  height={25}
                                                  alt=""
                                                />
                                                <div className="filerowname">
                                                  {file.name}
                                                </div>
                                              </div>
                                              {fileLoading ? (
                                                <div className="file-status">
                                                  <CircularProgressloader />
                                                </div>
                                              ) : (
                                                <div className="delet_file">
                                                  <IconButton
                                                    aria-label="delete"
                                                    onClick={() =>
                                                      handleDeleteFile(file)
                                                    }
                                                  >
                                                    <DeleteIcon />
                                                  </IconButton>
                                                </div>
                                              )}
                                            </div>
                                          ))}
                                        </div>
                                        <div className="col-12 mt-3">
                                          <div className="form-group text-center">
                                            <button
                                              type="button"
                                              className="btn btn-primary w-50"
                                              onClick={handleUpload}
                                            >
                                              Send to my brain
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="card h-100">
                            <div className="card-body">
                              <div className="whatpdf_title">
                                <h3>Knowledge</h3>
                                <p>
                                  View, download or delete knowledge used by
                                  your brain
                                </p>
                              </div>

                              {fileLoaded && knowledge.length === 0 && (
                                <div
                                  className="no_content-wrapper "
                                  style={{ display: "flex" }}
                                >
                                  <div className="no-content-box">
                                    <div className="no_content-icon">
                                      <img src={nopdf} alt="" height={100} />
                                    </div>
                                    <div className="no_content-title">
                                      Oh No, Your Brain is empty.
                                    </div>
                                    <div className="no_content-pera">
                                      <span>
                                        {" "}
                                        To add knowledge to a brain, go to chat
                                        page then click on plus button on the
                                        left of the chat input{" "}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              )}

                              {!fileLoaded && <PageLoader />}

                              <div className=" upload-pdflist ">
                                <ul>
                                  {knowledge &&
                                    knowledge.length > 0 &&
                                    fileLoaded &&
                                    knowledge.map((file, index) => {
                                      return (
                                        <li
                                          className={`${
                                            selectedLink === file.id
                                              ? "active"
                                              : ""
                                          }`}
                                          onClick={() => {
                                            setSelectedLink(file.id);
                                          }}
                                        >
                                          <Link to="#" className="active">
                                            <MarkUnreadChatAltOutlinedIcon fontSize="small" />
                                            <span>
                                              {file.file_name
                                                ? file.file_name
                                                : "NA"}
                                            </span>
                                          </Link>
                                          <Tooltip
                                            className="blue-tooltip"
                                            title="Delete Chat"
                                            placement="bottom"
                                            arrow
                                          >
                                            <span
                                              className=" "
                                              onClick={activedelet}
                                            >
                                              <DeleteOutlineOutlinedIcon fontSize="small" />
                                            </span>
                                          </Tooltip>
                                        </li>
                                      );
                                    })}
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div> */}
                    </TabPanel>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>

        <Modal open={opendelete} onClose={handleClosedelete} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
          <Box className=" commonpopup  modal-common   popup-w35 ">
            <Link className="close" onClick={handleClosedelete}>
              X
            </Link>
            <div className="modal-body">
            <div className="popup_scroller">
              <div className="icon-box">
                <i className="las la-trash-alt"></i>
              </div>
              <div className="model-content text-center">
                <h3>Are you sure you want to delete?</h3>
              </div>
              <div className="modal-btn">
                <button
                  className="btn btn-success btn-block  "
                  onClick={() => {
                    deleteUserAccess();
                    handleClosedelete();
                  }}
                >
                  Delete forever
                </button>
                <button className="btn btn-danger btn-block  " onClick={handleClosedelete}>
                  Cancel
                </button>
              </div>
            </div>
            </div>
          </Box>
        </Modal>
        <Modal open={openprompt} onClose={handleCloseprompt} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
          <Box className=" commonpopup  modal-common   popup-w35 ">
         
              <div className="card-item__content ">
                <div class="card-title">
                  <h2>Add New Prompt</h2>
                </div>
                <Link className="close" onClick={handleCloseprompt}>
                  X
                </Link>
              </div>
              <div className="modal-body">
              <div className="popup_scroller"> 

              <div className="popup-knowledge">
                <div className="col-12">
                  <div className="form-group">
                    <label> Prompt title</label>
                    <FormControl fullWidth size="small">
                      <TextField
                        id="outlined-basic"
                        type="text"
                        placeholder="Enter your prompt title"
                        size="small"
                        value={title}
                        onChange={(e) => {
                          setTitle(e.target.value);
                        }}
                      />
                    </FormControl>
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <label>Prompt content</label>
                    <FormControl fullWidth size="small">
                      <TextField
                        id="outlined-basic"
                        type="text"
                        placeholder="Enter your prompt content in brief"
                        multiline
                        rows={4}
                        value={content}
                        onChange={(e) => {
                          setContent(e.target.value);
                        }}
                      />
                    </FormControl>
                  </div>
                </div>
                <div className="col-12 mt-3">
                  <div className="form-group text-center">
                    <button
                      type="button"
                      className="btn btn-primary w-50"
                      onClick={() => {
                        submitPrompts();
                      }}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
              </div>
            </div>
          </Box>
        </Modal>
      </MainPage>
    </>
  );
};
